import HistoryBlock from './HistoryBlock';

export default HistoryBlock;
